'use strict';

angular.module('app')
  .factory('RecentlyViewed', function($http, $location, $window, $rootScope, Request, GTM, Auth) {
    var RecentlyViewed = {};


    RecentlyViewed.get = function() {
      return Request.get('account/recently-viewed/').then(function(res) {
        _.each(res.data, function(val) {
          if (val.shop) {
            val.isWishlist = val.shop.isWishlist;
          }
          if (val.divesite) {
            val.isWishlist = val.divesite.isWishlist;
          }
          if (val.country) {
            val.isWishlist = val.country.isWishlist;
          }
          if (val.area) {
            val.isWishlist = val.area.isWishlist;
          }
        });

        return _.sortBy(res.data, ['id', 'desc']);
      });
    };

    RecentlyViewed.add = function(data) {
      if (!Auth.getUser()) {
        return true;
      }

      return Request.post('account/recently-viewed/add/', data).then(function(res) {
        return res.data;
      });
    };

    return RecentlyViewed;

  });